import { isAbort, loadMedia } from '../data';
import { t, type TranslationKey } from '../i18n';
import { MEDIA_TYPES, type MediaItem, type MediaType } from '../types';
import { $, emptyState, errorState, h, loadingState } from '../ui/dom';
import { mediaCard } from '../ui/cards';

let controller: AbortController | null = null;
let filter: MediaType | null = null;
let query = '';

export async function mountMedia(params: URLSearchParams): Promise<void> {
  controller?.abort();
  controller = new AbortController();
  const signal = controller.signal;
  const grid = $('media-grid');
  const filters = $('media-filters');
  const count = $('media-count');
  const search = $('media-search') as HTMLInputElement | null;
  if (!grid || !filters) return;

  const typeParam = params.get('type');
  filter = (MEDIA_TYPES as string[]).includes(typeParam ?? '') ? (typeParam as MediaType) : null;

  let items: MediaItem[] = [];

  const drawFilters = (): void => {
    const chip = (type: MediaType | null, label: string): HTMLElement =>
      h('button', {
        class: `chip${filter === type ? ' active' : ''}`,
        attrs: { type: 'button', 'aria-pressed': filter === type },
        text: label,
        on: {
          click: () => {
            filter = type;
            history.replaceState(history.state, '', type ? `/media?type=${type}` : '/media');
            drawFilters();
            draw();
          },
        },
      });
    filters.replaceChildren(
      chip(null, t('common.all')),
      ...MEDIA_TYPES.map((m) => chip(m, t(`media.type.${m}` as TranslationKey))),
    );
  };

  const draw = (): void => {
    const q = query.trim().toLowerCase();
    const shown = items.filter(
      (m) =>
        (!filter || m.media_type === filter) &&
        (!q || m.title_ru.toLowerCase().includes(q) || (m.title_en ?? '').toLowerCase().includes(q)),
    );
    if (count) count.textContent = `${shown.length} / ${items.length}`;
    grid.replaceChildren(...(shown.length ? shown.map(mediaCard) : [emptyState(items.length ? 'media.nothingFound' : 'common.empty')]));
  };

  if (search) {
    search.value = query;
    search.oninput = () => {
      query = search.value;
      draw();
    };
  }

  drawFilters();
  grid.replaceChildren(loadingState());
  try {
    items = await loadMedia(signal);
    if (signal.aborted) return;
    draw();
  } catch (err) {
    if (!isAbort(err)) grid.replaceChildren(errorState(() => void mountMedia(params)));
  }
}

export function unmountMedia(): void {
  controller?.abort();
  controller = null;
}
